module.exports = __webpack_public_path__ + "img/ps.67375bb4.svg";